module.exports = __webpack_public_path__ + "static/img/axial-base-accessible-colorbar.7d40c40.png";